import { EditorProps } from '@monaco-editor/react';
import { Button, Card } from 'antd';
import { FC } from 'react';

import { AppMessage } from '@/common/components/AppMessage/AppMessage';

interface Props {
  fileContent: EditorProps['value'];
  disabled: boolean;
}

export const CodeEditorToolbar: FC<Props> = ({ fileContent, disabled }) => {
  const appMessageApi = AppMessage.useControls();

  const handleCopyContent = async () => {
    try {
      if (fileContent) {
        await navigator.clipboard.writeText(fileContent);
        appMessageApi.success('Контент скопійовано до буферу обміну', { duration: 2 });
      }
    } catch (error) {
      appMessageApi.error(`${ error }`);
    }
  };

  return (
    // <Alert
    //   style={{
    //     backgroundColor: colorBgContainerDisabled,
    //     borderColor: 'rgb(217 217 217)'
    //     // borderEndEndRadius: 0,
    //     // borderEndStartRadius: 0
    //   }}
    //   message={
    //     <Space>
    //       <Button size="small" type="dashed">Copy</Button>
    //     </Space>
    //   }
    // />
    <Card
      styles={{
        body: {
          padding: 4,
          background: '#f5f5f5',
          borderRadius: 4,
          overflow: 'hidden'
        }
      }}
      style={{
        border: 'none',
        borderEndEndRadius: 0,
        padding: 6,
        background: '#171717',
        borderEndStartRadius: 0,
        overflow: 'hidden',
        borderRadius: 0
      }}
    >
      <Button
        type="primary"
        size="small"
        disabled={ disabled || !fileContent }
        onClick={ handleCopyContent }
      >
        Copy
      </Button>
    </Card>
  );
};
